import { render, staticRenderFns } from "./LeccionC4.vue?vue&type=template&id=4db83248&"
import script from "./LeccionC4.vue?vue&type=script&lang=js&"
export * from "./LeccionC4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports